import { CommonModule, NgClass } from '@angular/common';
import { Component, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder, Validators } from '@angular/forms';
import { CoreSidebarModule } from '@core/components';
import { CoreDirectivesModule } from '@core/directives/directives';
import { TranslocoDirective } from '@jsverse/transloco';
import { NgbActiveModal, NgbModule, NgbNav, NgbNavContent, NgbNavItem, NgbNavItemRole, NgbNavLink, NgbNavLinkBase, NgbNavOutlet, NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { Actions, ofType } from '@ngrx/effects';
import { SharedModule } from 'app/main/shared/shared/shared.module';
import { Observable, takeUntil } from 'rxjs';
import { IPlaybooksItemDTO } from '../../../dto/playbooks-listening.dto';
import {
    EditPlaybookFacade,
    IAddEditPlaybookFacadeToken,
    IEditPlaybookFacade
} from "../../../playbooks/add-edit-playbook/add-edit-playbook.facade";
import { PlaybooksListeningFacadeService } from '../../../store/playbooks-listening.facade.service';
import * as PlaybookActions from '../../../store/playbooks.actions';
import { LegalHubGuidelinesTabComponent } from '../legal-hub-guidelines-tab/legal-hub-guidelines-tab.component';
import { LegalHubSettingsTabComponent } from '../legal-hub-settings-tab/legal-hub-settings-tab.component';
import { LHSubmitFormButtonTranslationKey } from '../legal-hub-side-bar';
import { LegalHubSideBarBaseComponent } from '../legal-hub-side-bar.base.component';

@Component({
  selector: 'app-edit-playbook-side-bar',
  standalone: true,
  imports: [
        CommonModule,
        SharedModule,
        TranslocoDirective,
        NgbTooltip,
        CoreSidebarModule,
        CoreDirectivesModule,
        NgClass,
        NgbNav,
        NgbNavContent,
        NgbNavItem,
        NgbNavItemRole,
        NgbNavLink,
        NgbNavLinkBase,
        ReactiveFormsModule,
        LegalHubSettingsTabComponent,
        NgbNavOutlet,
        FormsModule,
        NgSelectModule,
        LegalHubGuidelinesTabComponent,
        NgbModule
],
  templateUrl: './edit-playbook-side-bar.component.html',
  styleUrl: './edit-playbook-side-bar.component.scss',
    providers:[
        {
            provide: IAddEditPlaybookFacadeToken,
            useExisting: EditPlaybookFacade
        },
        {
            provide:LHSubmitFormButtonTranslationKey,
            useValue: 'Update button text (update button) - update'
        }
    ]
})
export class EditPlaybookSideBarComponent extends LegalHubSideBarBaseComponent implements OnInit, OnDestroy {
   loading$:Observable<boolean> = this._addEditPlaybookFacadeService.loading$;
   submitting$:Observable<boolean> = this._addEditPlaybookFacadeService.submitting$;

   @Input({required: true}) playbookId: number;

   constructor(
       private _formBuilder: UntypedFormBuilder,
       private _actions:Actions,
       _activeModal: NgbActiveModal,
       _playbooksListeningFacadeService:PlaybooksListeningFacadeService,
       @Inject(IAddEditPlaybookFacadeToken) _addEditPlaybookFacadeService:IEditPlaybookFacade) {
        super(_activeModal,_playbooksListeningFacadeService, _addEditPlaybookFacadeService);
   }


    ngOnInit(): void {
        super.ngOnInit();
        this.playbookForm = this._formBuilder.group({
            id: [this.playbookId, [Validators.required]],
            name: ['', Validators.required],
            category: ['', Validators.required],
            purpose: [''],
            usage: [''],
            status:[0, Validators.required], // 0 for draft, 1 for published
            color: [null, Validators.required],
            guidelines: this._formBuilder.array([])
        });
        (<IEditPlaybookFacade>this._addEditPlaybookFacadeService).onPlaybookLoad(this.playbookForm, this.playbookId);
        this.onRequestResponse();
    }

    ngOnDestroy(): void {
        super.ngOnDestroy();
    }


    private onRequestResponse():void{
        this._actions.pipe(
            ofType(PlaybookActions.updateGuidelineSucceeded),
            takeUntil(this.onDestroy$)
        ).subscribe(({playbooksItem}) => {
            this.updateGuidelineForm(playbooksItem);
        })
    }
    

    private updateGuidelineForm(guidelines:  IPlaybooksItemDTO[]):void{
        this._addEditPlaybookFacadeService.updateGuidelineForm(this.playbookForm, guidelines);
    }



    deletePlayBook(dataItemId: number) {
        this._playbooksListeningFacadeService.confirmAndDeletePlaybook(dataItemId);
    }
}